import { render, staticRenderFns } from "./TopCardTable.vue?vue&type=template&id=c0d3f71c&scoped=true"
import script from "./TopCardTable.vue?vue&type=script&lang=js"
export * from "./TopCardTable.vue?vue&type=script&lang=js"
import style0 from "./TopCardTable.vue?vue&type=style&index=0&id=c0d3f71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d3f71c",
  null
  
)

export default component.exports